import React, { useEffect, useRef } from 'react';
import WavePlayer from '../../components/WavePlayer';

export const AudioPreview = ({
  mp3Files,
  wavFiles,
  id,
  activeTrack,
  setActiveTrack,
  showButton = true,
  selectedTrack,
  onWavePlayerInit,
  onDuration,
}) => {
  const wavePlayerRef = useRef(null);

  useEffect(() => {
    return () => {
      // Cleanup when component unmounts
      if (wavePlayerRef.current) {
        wavePlayerRef.current = null;
      }
    };
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <div className="d-flex">
        <WavePlayer
          ref={wavePlayerRef}
          file={selectedTrack.downloadUrl}
          id={`previewAudioPlayer-${id}`}
          isActiveTrack={activeTrack === id}
          setActiveTrack={(id) => {
            if (typeof setActiveTrack === 'function') {
              setActiveTrack(id);
            }
          }}
          onInit={(wavePlayer) => {
            if (onWavePlayerInit) {
              onWavePlayerInit(wavePlayer);
            }
          }}
          onDuration={onDuration}
        />
      </div>
    </div>
  );
};
